import { AppRouter } from './routes';
import { useInitialiseApp } from '@/features';
import { useAuthInit } from '@/features/auth';
import { useAppSelector, selectAuthInitialized } from '@/app/store';
import { ThemeProvider } from './providers/ThemeProvider';
import { LanguageProvider } from './providers/LanguageProvider';
import { Toaster } from '@/shared/shadcn';

import '@/app/i18n/config'; // Import i18n configuration

function App() {
  const { getUserLanguage, isLoading: isAuthLoading } = useAuthInit();
  useInitialiseApp(isAuthLoading);
  const authInitialized = useAppSelector(selectAuthInitialized);

  const userLanguage = authInitialized ? getUserLanguage() : undefined;

  return (
    <ThemeProvider>
      <LanguageProvider initialLanguage={userLanguage}>
        {!isAuthLoading && <AppRouter />}
        <Toaster richColors position='bottom-right' className='mb-safe' />
      </LanguageProvider>
    </ThemeProvider>
  );
}

export default App;
